// Create a pass through element to allow me to instrument this in the CX. There is a case where we
//  still want to show the native version of the component (MicDrop)
import ConversationDetailsCX from './ConversationDetailsCX';
import ConversationDetailsNative from './ConversationDetailsNative';

import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { GlobalContext } from '../api/GlobalContext';
import { getHaveInjector } from '../EMR_Integration/react_webInjector.ts';

// Check if this EMR has a native integration
// TODO: (but there is also a case where we want the user to be able to manually enable micdrop mode...)

const ConversationDetails = () => {
  const { apiClient } = useContext(GlobalContext);
  const navigate = useNavigate();

  // Check if this EMR has a native integration and if it does not show the native version of the component
  const [showNative, setShowNative] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if this EMR has a native integration
    const fetchInjector = async () => {
      try {
        const haveInjector = await getHaveInjector();
        if (!haveInjector) {
          setShowNative(true);
        }
      } catch (error) {
        // Check if this is the specific error that requires navigation to home
        if (error.message === 'NAVIGATE_TO_HOME') {
          navigate('/User/home');
          return; // Don't set loading to false, let navigation handle it
        }

        // On other errors default to showing the CX
        setShowNative(true);
      }
      setIsLoading(false);
    };
    // If we should be forcing mic_drop mode then show the native version of the component
    if (apiClient.force_mic_drop) {
      setShowNative(true);
      setIsLoading(false);
    } else {
      fetchInjector();
    }
  }, [navigate]);

  return (
    <>
      {isLoading ? null : (
        <>
          {showNative ? (
            <ConversationDetailsNative />
          ) : (
            <ConversationDetailsCX />
          )}
        </>
      )}
    </>
  );
};

export default ConversationDetails;
